import { Loader as DynamonLoader } from '@dynamon-as/ui';
import React from 'react';

/**
 * Global Loader component that wraps @dynamon-as/ui Loader
 * Provides consistent loading indicator across the application
 */
export interface GlobalLoaderProps {
    /**
     * Additional CSS class
     */
    className?: string;
    /**
     * Whether the loader is currently loading
     * @default true
     */
    isLoading?: boolean;
}

/**
 * Global Loader component
 * Uses @dynamon-as/ui Loader internally with overlay variant
 */
export const GlobalLoader: React.FC<GlobalLoaderProps> = ({
    className = '',
    isLoading = true,
}): React.ReactElement | null => {
    if (!isLoading) {
        return null;
    }

    return (
        <div className={className}>
            <DynamonLoader
                isLoading={isLoading}
                variant="overlay"
            />
        </div>
    );
};

/**
 * Default export for convenience
 */
export default GlobalLoader;
